import { render, staticRenderFns } from "./bairunSerialNumber.vue?vue&type=template&id=4d55ecd6&"
import script from "./bairunSerialNumber.vue?vue&type=script&lang=js&"
export * from "./bairunSerialNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d55ecd6')) {
      api.createRecord('4d55ecd6', component.options)
    } else {
      api.reload('4d55ecd6', component.options)
    }
    module.hot.accept("./bairunSerialNumber.vue?vue&type=template&id=4d55ecd6&", function () {
      api.rerender('4d55ecd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/bairunSerialNumber/bairunSerialNumber.vue"
export default component.exports